<script setup>
  import {onBeforeMount, onMounted, provide, reactive, useSlots} from "vue";

  import ComponentBadge from "@components/Badges/Badge.vue";
  import {cn} from "@pharma4u/medicheck-components/utils";

  const slots = useSlots();

  defineOptions({
    name: "ComponentTabs",
  });

  const props = defineProps({
    activeTab: {
      type: String,
      default: "",
    },
  });

  const emit = defineEmits(["click"]);

  const state = reactive({
    selectedIndex: 0,
    tabs: [],
    count: 0,
  });

  provide("tabsProvider", state);

  onBeforeMount(() => {
    if (slots.default) {
      state.tabs = slots.default().filter((child) => child.type.name === "ComponentTab");
    }
  });

  onMounted(() => {
    const tabIndex = state.tabs.findIndex((tab) => tab.props?.title === props.activeTab);
    selectTab(Math.max(tabIndex, 0));
  });

  const selectTab = (index_) => {
    state.selectedIndex = index_;
    for (const [index, tab] of state.tabs.entries()) {
      tab.isActive = index === index_;
      if (index === index_) {
        emit("click", tab.props.title);
      }
    }
  };
</script>

<template lang="html">
  <div>
    <div class="flex space-x-2">
      <template v-for="(tab, index) in state.tabs">
        <template v-if="tab.props?.title">
          <button
            :key="tab.props.title"
            :class="
              cn('inline-block rounded-t-md p-4 font-semibold text-gray-900 hover:bg-gray-100 enabled:cursor-pointer', {
                'border-b-2 border-mcred bg-mcred-100/50 text-mcred hover:bg-mcred-100 hover:text-mcred-700':
                  tab.props.title === activeTab,
              })
            "
            :data-test="`${tab.props['test-id'] ? tab.props['test-id'] + '-' : ''}tab`"
            @click="selectTab(index)"
          >
            <span v-if="tab.props?.infoMessage > 0">
              <ComponentBadge>
                <template #icon>{{ tab.props?.infoMessage }}</template>

                {{ tab.props.title }}
              </ComponentBadge>
            </span>

            <span v-else>{{ tab.props.title }}</span>
          </button>
        </template>
      </template>
    </div>
    <slot />
  </div>
</template>
